import type { ExpectedUserBenefitType } from '@openclassrooms/sdk-web';

const prioritizedBenefits: Array<ExpectedUserBenefitType> = [
  'expect_recruit_apprentices',
  'expect_recruit_graduates',
  'expect_train_employees',
  'expect_first_job',
  'expect_change_career',
  'expect_boost_career',
  'expect_learn_for_fun',
  'expect_other_benefit',
];

export interface BenefitEntity {
  id?: string;
  [others: string]: any;
}
const getMostRelevantBenefit = (benefits?: Array<BenefitEntity>): ExpectedUserBenefitType | '' => {
  if (!benefits || benefits.length === 0) return '';

  const userBenefitsIds: Array<ExpectedUserBenefitType> = Array.from(
    benefits,
    (item: BenefitEntity): ExpectedUserBenefitType => item.id as ExpectedUserBenefitType
  );

  const mostRelevantBenefits = userBenefitsIds.sort(
    (a, b) => prioritizedBenefits.indexOf(a) - prioritizedBenefits.indexOf(b)
  );

  return mostRelevantBenefits[0];
};

export default getMostRelevantBenefit;
